import { pct } from "../lib/format";

const ORDER_COLORS = {
  Delivered: "bg-emerald-100 text-emerald-700",
  Approved: "bg-teal-100 text-teal-700",
  Ordered: "bg-amber-100 text-amber-700",
  "In Transit": "bg-blue-100 text-blue-700",
  "Pending Approval": "bg-amber-100 text-amber-700",
  Draft: "bg-slate-100 text-slate-600",
  Cancelled: "bg-rose-100 text-rose-700",
};
const PAY_COLORS = {
  Paid: "bg-emerald-100 text-emerald-700",
  Pending: "bg-amber-100 text-amber-700",
  Partial: "bg-amber-100 text-amber-700",
  Unpaid: "bg-rose-100 text-rose-700",
};

export const StatusBadge = ({ value, type = "order", testid }) => {
  const map = type === "payment" ? PAY_COLORS : ORDER_COLORS;
  const cls = map[value] || "bg-slate-100 text-slate-600";
  return (
    <span data-testid={testid} className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${cls}`}>
      {value || "—"}
    </span>
  );
};

export const KpiCard = ({ label, value, sub, icon: Icon, tone = "teal", testid }) => {
  const tones = {
    teal: "text-brand-teal bg-teal-50",
    emerald: "text-brand-emerald bg-emerald-50",
    amber: "text-amber-600 bg-amber-50",
    rose: "text-rose-600 bg-rose-50",
    navy: "text-navy bg-slate-100",
  };
  return (
    <div data-testid={testid} className="bg-white rounded-xl border border-border p-6 transition-transform hover:-translate-y-1 hover:shadow-sm">
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-brand-slate font-semibold">{label}</div>
          <div className="mt-2 font-heading text-3xl font-bold text-navy tabular-nums">{value}</div>
          {sub && <div className="mt-1 text-sm text-brand-slate">{sub}</div>}
        </div>
        {Icon && <div className={`w-11 h-11 rounded-lg flex items-center justify-center ${tones[tone]}`}><Icon className="w-5 h-5" /></div>}
      </div>
    </div>
  );
};

export const SectionCard = ({ title, action, children, className = "" }) => (
  <div className={`bg-white rounded-xl border border-border ${className}`}>
    {(title || action) && (
      <div className="flex items-center justify-between px-6 py-4 border-b border-border">
        <h3 className="font-heading font-semibold text-navy">{title}</h3>
        {action}
      </div>
    )}
    <div className="p-6">{children}</div>
  </div>
);

export const Th = ({ children, className = "" }) => (
  <th className={`text-left uppercase text-[11px] tracking-wider text-brand-slate font-semibold px-4 py-3 whitespace-nowrap ${className}`}>{children}</th>
);
export const Td = ({ children, className = "" }) => (
  <td className={`px-4 py-3 text-sm text-navy whitespace-nowrap ${className}`}>{children}</td>
);

export const Bar = ({ value, warn }) => (
  <div className="w-full h-2 rounded-full bg-slate-100 overflow-hidden">
    <div className={`h-full rounded-full ${warn ? "bg-rose-500" : "bg-brand-teal"}`} style={{ width: `${Math.min(100, value * 100)}%` }} />
  </div>
);

export const Stars = ({ rating }) => (
  <span className="text-amber-500 tabular-nums" title={`${rating}/5`}>
    {"★".repeat(Math.round(rating))}<span className="text-slate-300">{"★".repeat(5 - Math.round(rating))}</span>
  </span>
);

export const Empty = ({ icon: Icon, msg }) => (
  <div className="flex flex-col items-center justify-center py-16 text-center">
    {Icon && <Icon className="w-10 h-10 text-slate-300 mb-3" />}
    <p className="text-brand-slate text-sm">{msg}</p>
  </div>
);

export { pct };
